import UserStore from './UserStore';

export default {
    userStore: new UserStore()
};
